import { ulid } from 'ulid'

/**
 * Builds a unique ICS2 ENS master transport document (CMR) reference number.
 *
 * Format: `{EORI}{ULID}` concatenated with no separator.
 *
 * Rationale:
 * - ICS2 requires the master transport document reference to be unique across its central
 *   repository (validation code 81 - "Duplicate Transport Document Reference") and rejects
 *   non-alphanumeric characters (error BASIC). A Crockford-base32 ULID is alphanumeric and
 *   uppercase, so the EORI prefix is normalised to alphanumeric uppercase to keep the whole
 *   value compliant - hence no separator.
 * - The carrier EORI prefix namespaces the reference to this operator, so it cannot collide
 *   with another haulier's references in the shared repository.
 * - The ULID (timestamp + entropy) guarantees uniqueness across this carrier's own filings
 *   without any central allocator.
 *
 * The value is only a default - the user may overwrite it with a real CMR note number.
 *
 * @param carrierEori the carrier EORI to use as a prefix; when absent the ULID alone is returned.
 */
export default function generateTransportDocumentReference(carrierEori?: string | null): string {
  const prefix = (carrierEori ?? '').toUpperCase().replace(/[^A-Z0-9]/g, '')
  return `${prefix}${ulid()}`
}
